<template>
  <div class="monitor-container">
    <!-- :deviceNum="'only'" -->
    <search
      :formModel="formModel"
      :formButton="formButton"
      :rules="rules"
      :mul-time="mulTime"
      :deviceModelBusiType="1"
      :upLeveName="'monitor'"
    ></search>
    <v-main class="monitor-content" :loading="loading">
      <el-card class="v-block" :header="'一、概述' | translateTo(i18nPath)">
        <p class="overview">
          <span>{{ overview }}</span>
          <span v-if="!overview">{{ '暂无数据' | translateTo(i18nPath) }}</span>
        </p>
      </el-card>
      <el-card :header="'二、设备总体运行情况' | translateTo(i18nPath)" class="v-block mt-15">
        <template v-for="(e, i) in data">
          <part
            type="line"
            option="table,chart"
            :sn="e.sn"
            :key="e.sn"
            :names="e.names"
            :chart-opts="e.opts"
            :i18n-path="i18nPath"
            :table-data="e.tableData"
            :table-cfg="getTableCfg()"
            :header="`${i + 1}、(${e.sn})`"
          ></part>
        </template>
        <span class="hint" v-if="!data || !data.length">
          {{ '暂无数据' | translateTo(i18nPath) }}
        </span>
      </el-card>
      <part
        :header="'三、设备报警情况' | translateTo(i18nPath)"
        type="bar"
        option="chart,tips"
        :show="!!alarm"
        :names="['alarm']"
        :i18n-path="i18nPath"
        v-bind="alarm"
      ></part>
      <part
        :header="'四、数据分布情况' | translateTo(i18nPath)"
        type="boxplot"
        option="chart,tips"
        :show="!!diffusion"
        :i18n-path="i18nPath"
        :names="['diffusion']"
        v-bind="diffusion"
      ></part>
      <el-card :header="'五、分析总结' | translateTo(i18nPath)" class="v-block mt-15">
        <part
          option="table"
          v-for="(opt, i) in summary.tables"
          :key="opt.type"
          :i18n-path="i18nPath"
          :header="`${i + 1}、（${opt.type}）`"
          :table-cfg="{ ...summary.opt, ...opt }"
        ></part>
        <span v-if="!notEmpty(summary.tables)">{{ '暂无数据' | translateTo(i18nPath) }}</span>
      </el-card>
    </v-main>
  </div>
</template>

<script>
import { getMonitorAnalysis } from '@/api/dataAnalysis';
import Search from '@/components/mTable/search';
import VMain from './components/v-main';
import Part from './components/part.vue';
import { search } from './utils/monitoring-mixin';
import {
  convertData,
  convertSummaryTable,
  convertAlarmData,
  convertDiffusionData,
  validParam,
  imgsKeyParser
} from './utils/index';
import { canvasToImg, downFile, arrify } from '@/utils/utils';
import { notEmpty } from '@/utils/validator';
import { isEmpty } from '@/utils/is';

export default {
  mixins: [search],
  components: {
    Search,
    VMain,
    Part
  },
  data() {
    return {
      i18nPath: 'dataAnalysis',
      loading: true,
      overview: '',
      data: null,
      alarm: null,
      diffusion: null,
      summary: {
        tables: [],
        opt: {
          spanMethod({ row, columnIndex }) {
            if (row.name === '总结') {
              if (columnIndex >= 1) {
                if (columnIndex === 4) {
                  return [1, 4];
                }
                return [0, 0];
              } else if (columnIndex === 1) {
                return [0, 0];
              }
            }
          },
          cellClassName({ row, columnIndex }) {
            if (row.name === '总结' && columnIndex === 4) {
              return 'ws-preline';
            }
          }
        }
      }
    };
  },
  methods: {
    notEmpty,
    initSearchHooks() {
      this.searchHooks.set('resetData', this.resetData);
      this.searchHooks.set('getData', this.getData);
      this.searchHooks.set('changeDateRangeText', this.changeDateRangeText);
    },
    getData() {
      const { sn, rangeDateVal, officeId, taskId, deviceModel } = this.formModel;
      const param = validParam({
        sn: arrify(sn || null),
        beginTime: rangeDateVal[0],
        endTime: rangeDateVal[1],
        officeId,
        taskId,
        deviceTypeCode: deviceModel
      });
      getMonitorAnalysis(param).then(res => {
        if (!isEmpty(res.data)) {
          const { alarm, data, description, diffusion, summary } = res.data;
          this.overview = description;
          !isEmpty(data) && this.$set(this, 'data', convertData(data));
          !isEmpty(alarm) && this.$set(this, 'alarm', convertAlarmData(alarm));
          !isEmpty(diffusion) && this.$set(this, 'diffusion', convertDiffusionData(diffusion));
          !isEmpty(summary) &&
            this.summary.tables.splice(0, Infinity, ...convertSummaryTable(summary));
        }
        this.loading = false;
      });
    },
    resetData() {
      this.loading = true;
      this.data = null;
      this.alarm = null;
      this.diffusion = null;
      this.summary.tables.splice(0, Infinity);
    },
    exportData() {
      this.formButton[1].loading = true;
      const { sn, rangeDateVal, officeId, taskId, deviceModel } = this.formModel;
      canvasToImg().then(imgs => {
        downFile({
          url: '/stat/exportMonitorAnalysis',
          method: 'post',
          data: validParam({
            sn: arrify(sn),
            beginTime: rangeDateVal[0],
            endTime: rangeDateVal[1],
            officeId,
            taskId,
            deviceTypeCode: deviceModel,
            pics: imgsKeyParser(imgs)
          })
        }).finally(() => {
          this.formButton[1].loading = false;
        });
      });
    },
    getTableCfg() {
      return {
        tableColumn: [
          { prop: 'name', label: '监测项' },
          { prop: 'avg', label: '平均值' },
          { prop: 'max', label: '最大值' },
          { prop: 'min', label: '最小值' }
        ]
      };
    }
  }
};
</script>

<style lang="scss">
.monitor-container {
  height: 100%;
  .monitor-content {
    margin-top: 10px;
    background: $bg-color;
    height: calc(100% - 120px);
    .overview {
      white-space: pre-line;
    }
  }
  .ws-preline {
    .cell {
      white-space: inherit;
      text-align: left;
    }
  }
}
</style>
